export const HELP_CENTER_HOW_TO_CONFIGURE_SSO =
  'https://helpcenter.enterpret.com/en/collections/3796955-single-sign-on-sso';
